import { KeyValue } from '@/main/models/common';
import { CompanyFilterRequest } from '@/main/models/request';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum CompanyTypes {
  GET_COMPANY = '@company/GET_COMPANY',
  SAVE_COMPANY = '@company/SAVE_COMPANY',
  GET_COMPANY_ALL = '@company/GET_COMPANY_ALL',
  SAVE_COMPANY_ALL = '@company/SAVE_COMPANY_ALL',
  RESET_REDUCER_COMPANY = '@company/RESET_REDUCER_COMPANY'
}

export interface CompanyState {
  readonly company: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly companyAll: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetCompany {
  type: typeof CompanyTypes.GET_COMPANY;
  payload: {
    request: CompanyFilterRequest;
    keyReducer: string;
  };
}
export interface GetCompanyAll {
  type: typeof CompanyTypes.GET_COMPANY_ALL;
  payload: {
    request: CompanyFilterRequest;
    keyReducer: string;
  };
}

export interface SaveCompany {
  type: typeof CompanyTypes.SAVE_COMPANY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}
export interface SaveCompanyAll {
  type: typeof CompanyTypes.SAVE_COMPANY_ALL;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerCompany {
  type: typeof CompanyTypes.RESET_REDUCER_COMPANY;
}

export type CompanyActionTypes =
  | GetCompany
  | GetCompanyAll
  | SaveCompany
  | SaveCompanyAll
  | ResetReducerCompany;

